import { RootState } from "@/stores/rootReducer";
import { useMemo } from "react";
import { useSelector } from "react-redux";

const useMyself = (targetUserId: number): boolean => {
  const { user } = useSelector((state: RootState) => state.auth);
  const isMyself = useMemo<boolean>(() => {
    if (!user) {
      return false;
    }

    return user.id === targetUserId;
  }, [targetUserId, user]);

  return isMyself;
};

export default useMyself;
